export default "__VITE_ASSET__DE3elmXX__"